import { LoanInventoryTableFields } from '../HbtPortfolioLoansInventoryTable/types';

export type RightPaneContentProps = {
  handleCloseFlyout: () => void;
  count: number;
  subHeaderText: string;
  bodyContent: string;
  noResultsBodyContent: string;
  selectedRowSubHeaderData: string;
  moreThenOneIsSelectedContent: string;
  noErrorsContent: string;
  data: LoanInventoryTableFields[];
};

export interface LoansErrorHookProps {
  errorMessageDescriptionID: string;
  errorMessageEnglish: string;
  errorMessageFrench: string;
}

export type ErrorMessageInfo = string;

export const SeverityCodes = {
  requiresReview: 'requires review',
  warning: 'warning',
  error: 'error',
  info: 'info'
} as const;

export type SeverityCode = (typeof SeverityCodes)[keyof typeof SeverityCodes];

export type MappedCodes = Record<string, LoansErrorHookProps>;
export type GroupedErrors = Partial<Record<SeverityCode, MappedCodes>>;
